export class GenericHeapElement {
    // value
    constructor(index, priority, v) {
        this.indexToA = index;
        this.priority = priority;
        this.v = v;
    }
}
//# sourceMappingURL=genericHeapElement.js.map